import { Flex, Text } from '@mantine/core';
import { FieldTypeMetadata, FieldValue } from '../types';
import { DataInput } from './DataInput';
import { EntityCategory } from '../stores/useDetectedEntitiesStore';
import { IconArrowNarrowRight } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type ValueChangeProps = {
  label?: string;
  newValue: FieldValue;
  previousValue: FieldValue;
  metadata?: FieldTypeMetadata;
  category: EntityCategory;
};

export default function ValueChange({
  label,
  newValue,
  previousValue,
  metadata,
  category,
}: ValueChangeProps) {
  return (
    <Flex gap="xxxs" align="center">
      {label && (
        <Text fw={500} size="sm" c="gray.10">
          {label}:
        </Text>
      )}
      <DataInput editable={false} highlight="existing" metadata={metadata} category={category}>
        {previousValue}
      </DataInput>
      <IconArrowNarrowRight size={14} fontWeight={FONT_WEIGHTS.regular} />
      <DataInput editable={false} highlight="new" metadata={metadata} category={category}>
        {newValue}
      </DataInput>
    </Flex>
  );
}
